import { get } from 'lodash';
import { dataPoints } from './constants';

export const guestMetricsCount = (metrics) => get(metrics, `datasets.${dataPoints.PUBLIC}`, 0);

export const metricsCount = (metrics) => get(metrics, `datasets.${dataPoints.INTERNAL}`, 0)
+ get(metrics, `datasets.me.${dataPoints.PRIVATE}`, 0);

export const metricsCountCommonsMode = (metrics) => get(metrics, `datasets.${dataPoints.INTERNAL}`, 0)
+ get(metrics, `datasets.me.${dataPoints.PRIVATE}`, 0)
+ get(metrics, `datasets.${dataPoints.PUBLIC}`, 0);

export const getCountType = (metrics, isGuest, commonsMode) => {
  if (isGuest) {
    return guestMetricsCount(metrics);
  }
  if (commonsMode) {
    return metricsCountCommonsMode(metrics);
  }
  return metricsCount(metrics);
};
